import { Player, Stats, ApiResponse, SeasonApiResponse, SeasonStats } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://karpatapiv3-etm2jtz53q-lz.a.run.app';

export const api = {
  async getPlayers(): Promise<Player[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/players`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data: ApiResponse<Player[]> = await response.json();
      return data.players || [];
    } catch (error) {
      console.error('Error fetching players:', error);
      throw error;
    }
  },

  async getSeasons(): Promise<SeasonApiResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/players`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data: SeasonApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching seasons:', error);
      throw error;
    }
  },

  async getStats(): Promise<SeasonStats> {
    try {
      const response = await fetch(`${API_BASE_URL}/stats`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data: SeasonStats = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching stats:', error);
      throw error;
    }
  }
};
